import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  Box, Paper, Typography, Grid, TextField, Button, Card, CardContent,
  Autocomplete, Alert, Snackbar, IconButton, LinearProgress,
  Container, Breadcrumbs, Link, Divider, InputAdornment, Tooltip,
  CircularProgress, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import {
  Person, Business, Save, Map, CloudUpload, AttachFile,
  Delete as DeleteIcon, ArrowBack, Calculate, AddCircleOutline,
  Visibility, Close
} from '@mui/icons-material';
import { Chip } from '@mui/material';
import { getProjects, getPlotsByProject } from '../../services/project';
import { createLandOwnership, getAllLandOwnershipRecords, getLandOwnershipRecordById, deleteLandOwnership, restoreLandOwnership } from '../../services/purchase';
import { globalMasterService } from '../../services/stateAPI';
import axios from 'axios';
import AlertModal from '../../components/AlertModal';
import ConfirmModal from '../../components/ConfirmModal';


const uploadImage = async (file, category = 'associate') => {
  try {
    const formData = new FormData();
    formData.append('image', file);

    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Authentication token not found. Please log in again.');
    }

    const API_BASE = process.env.REACT_APP_API_BASE_URL
    const fullAPIBase = API_BASE.startsWith('http') ? API_BASE : `http://${API_BASE}`;

    const response = await axios.post(
      `${fullAPIBase}/api/aws/upload-image?category=${category}`,
      formData,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        timeout: 30000
      }
    );

    if (response.data && response.data.status === true) {
      return response.data.data.viewUrl;
    } else {
      throw new Error(response.data.message || response.data.error || 'Failed to upload image');
    }
  } catch (error) {
    if (error.response) {
      console.error('Response data:', error.response.data);
      console.error('Response status:', error.response.status);
      console.error('Response headers:', error.response.headers);
      throw new Error(`Upload failed: ${error.response.data.message || error.response.data.error || error.response.statusText}`);
    } else if (error.request) {
      console.error('Request data:', error.request);
      throw new Error('Upload failed: No response received from server');
    } else {
      console.error('Error message:', error.message);
      throw new Error(`Upload failed: ${error.message}`);
    }
  }
};

const AddPurchasePage = ({ onAddPurchase, editMode = false, editData = null, onBack }) => {
  const getProjectsPaginated = async (options = {}) => {
    try {
      const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/projects`;
      const params = {};
      if (options.page) {
        params.page = options.page;
      }
      if (options.limit) {
        params.limit = options.limit;
      }
      const response = await axios.get(API_BASE, { params });
      return response.data;
    } catch (error) {
      return { data: [], extra: { page: 1, limit: 10, total: 0 } };
    }
  };

  const [formData, setFormData] = useState({
    projectName: null,
    selectedPlots: [],
    farmers: [
      {
        name: '',
        fullNameHindi: '',
        fatherHusbandName: '',
        mobileNumber: '',
        alternateMobile: '',
        email: '',
        address: '',
        village: '',
        post: '',
        tehsil: '',
        district: '',
        state: '',
        pincode: '',
        aadhaar: '',
        pan: '',
        dob: '',
        age: '',
        bankAccount: '',
        ifscCode: '',
        bankName: '',
        branchName: '',
        accountHolderName: '',
        accountType: '',
        cancelledCheque: null,
        sellerType: 'Individual',
        documents: {},
        sellerPhoto: null,
        aarajiNumber: '',
        gataNumber: '',
        unitType: '',
        totalRakba: '',
        vedhanicAnsh: '',
        rate: '',
        totalAmount: '',
        paidAmount: '',
        outstandingAmount: '',
        paymentDate: '',
        paymentMode: '',
        refNumber: '',

      }
    ],
    state: '',
    district: '',
    tehsil: '',
    village: '',
    khataNo: '',
    gataNo: '',
    plotNo: '',
    landType: '',
    landUsage: '',
    totalArea: '',
    unit: '',
    rakhba: '',
    areaRevenueRecord: '',
    areaSurvey: '',
    eastBoundary: '',
    westBoundary: '',
    northBoundary: '',
    southBoundary: '',
    legalStatus: '',
    encumbranceStatus: '',
    courtCase: '',
    bankMortgage: '',
    leaseAgreement: '',
    purchaseId: '',
    purchaseDate: '',
    agreementType: '',
    ratePerUnit: '',
    totalDealAmount: '',
    advanceAmount: '',
    paidAmount: '',
    balanceAmount: '',
    stampDutyValue: '',
    circleRate: '',
    registryDate: '',
    mutationDate: '',
    registryOffice: '',
    witnessNames: '',
    brokerName: '',
    paymentId: '',
    paymentFarmerName: '',
    paymentLandReference: '',
    paymentDate: '',
    paymentType: '',
    bankName: '',
    referenceNumber: '',
    paymentAmount: '',
    paidFor: '',
    paymentRemarks: '',
    paymentAttachment: null,
    totalRakba: '',
    ratePerBiswa: '',
    totalAreaSqFt: '',
    purchaseAmount: '',
    landDocuments: {}
  });

  const [globalLand, setGlobalLand] = useState({
    state: '',
    district: '',
    tehsil: '',
    village: '',
    landType: '',
    landUsage: '',
    khataNumber: '',
    gataNumber: '',
    unit: '',
    totalRakba: '',
  });

  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  const hasFarmerErrors = (index) => {
    return Object.keys(errors).some(key => key.startsWith(`farmer_${index}_`));
  };

  // Modal states
  const [alertConfig, setAlertConfig] = useState({ open: false, title: 'Alert', message: '', type: 'info' });
  const [confirmConfig, setConfirmConfig] = useState({ open: false, title: 'Confirm', message: '', onConfirm: null });

  const showAlert = (message, type = 'info', title = 'Alert') => {
    setAlertConfig({ open: true, title, message, type });
  };

  const showConfirm = (message, onConfirm, title = 'Confirm') => {
    setConfirmConfig({ open: true, title, message, onConfirm });
  };


  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const [plots, setPlots] = useState([]);
  const [loadingPlots, setLoadingPlots] = useState(false);
  const [plotSearchTerm, setPlotSearchTerm] = useState('');

  const [statesList, setStatesList] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [citiesList, setCitiesList] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [stateSearchInput, setStateSearchInput] = useState('');

  const [banksList, setBanksList] = useState([]);
  const [loadingBanks, setLoadingBanks] = useState(false);

  const [unitTypes, setUnitTypes] = useState([]);
  const [loadingUnitTypes, setLoadingUnitTypes] = useState(false);
  const [landTypes, setLandTypes] = useState([]);
  const [loadingLandTypes, setLoadingLandTypes] = useState(false);
  const [landUsages, setLandUsages] = useState([]);
  const [loadingLandUsages, setLoadingLandUsages] = useState(false);
  const [paymentModes, setPaymentModes] = useState([]);
  const [loadingPaymentModes, setLoadingPaymentModes] = useState(false);

  const [addCityDialogOpen, setAddCityDialogOpen] = useState(false);

  // Image Preview State
  const [imageDialogOpen, setImageDialogOpen] = useState(false);
  const [imageDialogUrl, setImageDialogUrl] = useState('');
  const [imageDialogTitle, setImageDialogTitle] = useState('');

  const cleanImageUrl = (url) => {
    if (!url) return '';
    return typeof url === 'string' ? url.trim() : '';
  };

  const openImagePreview = (url, title) => {
    if (!url) return;
    setImageDialogUrl(cleanImageUrl(url));
    setImageDialogTitle(title || 'Image Preview');
    setImageDialogOpen(true);
  };
  const [newCityName, setNewCityName] = useState('');
  const [currentFarmerIndex, setCurrentFarmerIndex] = useState(0);

  const [uploadingDocuments, setUploadingDocuments] = useState({});
  const [documentUrls, setDocumentUrls] = useState({
    farmers: formData.farmers.map(() => ({
      cancelledChequeUrl: '',
      aadharFront: '',
      aadharBack: '',
      pan: '',
      voterIdFront: '',
      voterIdBack: '',
      signature: '',
      sellerPhoto: '',
      otherDocuments: ''
    })),

    land: {
      kahtuniCertificate: '',
      purchaseAgreement: '',
      landRevenueReceipt: '',
      otherDocuments: ''
    },
    paymentAttachment: ''
  });

  useEffect(() => {
    loadProjects(1, true);
  }, []);

  useEffect(() => {
    setDocumentUrls(prev => ({
      ...prev,
      farmers: formData.farmers.map((_, index) =>
        prev.farmers[index] || {
          cancelledChequeUrl: '',
          aadharFront: '',
          aadharBack: '',
          pan: '',
          voterIdFront: '',
          voterIdBack: '',
          signature: '',
          sellerPhoto: '',
          otherDocuments: ''
        }
      )
    }));
  }, [formData.farmers.length]);

  useEffect(() => {
    const loadStates = async () => {
      setLoadingStates(true);
      try {
        const states = await globalMasterService.getStates();
        setStatesList(states);
      } catch (error) {
        console.error('Failed to load states:', error);
        setStatesList(['Delhi', 'Maharashtra', 'Karnataka', 'Tamil Nadu', 'West Bengal']);
      } finally {
        setLoadingStates(false);
      }
    };

    loadStates();
  }, []);

  useEffect(() => {
    const loadCities = async () => {
      setLoadingCities(true);
      try {
        const cities = await globalMasterService.getCities();
        setCitiesList(cities);
      } catch (error) {
        console.error('Failed to load cities:', error);
        setCitiesList([
          { cityName: 'Varanasi', state: 'UP' },
          { cityName: 'Lucknow', state: 'UP' },
          { cityName: 'Kanpur', state: 'UP' },
          { cityName: 'Nainital', state: 'UK' },
          { cityName: 'Dehradun', state: 'UK' },
        ]);
      } finally {
        setLoadingCities(false);
      }
    };

    loadCities();
  }, []);

  useEffect(() => {
    const loadBanks = async () => {
      setLoadingBanks(true);
      try {
        const banks = await globalMasterService.getBanks();
        setBanksList(banks);
      } catch (error) {
        console.error('Failed to load banks:', error);
        setBanksList([
          { id: 'bank-sbi', name: 'State Bank Of India', value: 'State Bank Of India' },
          { id: 'bank-hdfc', name: 'HDFC Bank', value: 'HDFC Bank' },
          { id: 'bank-icici', name: 'ICICI Bank', value: 'ICICI Bank' },
          { id: 'bank-axis', name: 'Axis Bank', value: 'Axis Bank' },
        ]);
      } finally {
        setLoadingBanks(false);
      }
    };

    loadBanks();
  }, []);

  useEffect(() => {
    const loadUnitTypes = async () => {
      setLoadingUnitTypes(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/globalMasterDetails?type=unitType`
        );
        if (response.ok) {
          const result = await response.json();
          const unitTypes = Array.isArray(result.data)
            ? result.data
              .filter((item) => item.status === true)
              .map((item) => ({
                id: item._id,
                name: item.details?.name || 'Unknown',
              }))
            : [];
          setUnitTypes(unitTypes);
        }
      } catch (error) {
        console.error('Failed to load unit types:', error);
        setUnitTypes([]);
      } finally {
        setLoadingUnitTypes(false);
      }
    };

    const loadLandTypes = async () => {
      setLoadingLandTypes(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/globalMasterDetails?type=landType`
        );
        if (response.ok) {
          const result = await response.json();
          const landTypes = Array.isArray(result.data)
            ? result.data
              .filter((item) => item.status === true)
              .map((item) => ({
                id: item._id,
                name: item.details?.name || 'Unknown',
              }))
            : [];
          setLandTypes(landTypes);
        }
      } catch (error) {
        console.error('Failed to load land types:', error);
        setLandTypes([]);
      } finally {
        setLoadingLandTypes(false);
      }
    };

    const loadLandUsages = async () => {
      setLoadingLandUsages(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/globalMasterDetails?type=landUsage`
        );
        if (response.ok) {
          const result = await response.json();
          const landUsages = Array.isArray(result.data)
            ? result.data
              .filter((item) => item.status === true)
              .map((item) => ({
                id: item._id,
                name: item.details?.name || 'Unknown',
              }))
            : [];
          setLandUsages(landUsages);
        }
      } catch (error) {
        console.error('Failed to load land usages:', error);
        setLandUsages([]);
      } finally {
        setLoadingLandUsages(false);
      }
    };

    const loadPaymentModes = async () => {
      setLoadingPaymentModes(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/globalMasterDetails?type=paymentmode`
        );
        if (response.ok) {
          const result = await response.json();
          const pModes = Array.isArray(result.data)
            ? result.data
              .filter((item) => item.status === true)
              .map((item) => ({
                id: item._id,
                name: item.details?.paymentMode || 'Unknown',
              }))
            : [];
          setPaymentModes(pModes);
        }
      } catch (error) {
        console.error('Failed to load payment modes:', error);
        setPaymentModes([]);
      } finally {
        setLoadingPaymentModes(false);
      }
    };

    loadUnitTypes();
    loadLandTypes();
    loadLandUsages();
    loadPaymentModes();
  }, []);

  const getCityOptions = (farmerState) => {
    if (!farmerState) {
      return citiesList.map(city => city.cityName || city);
    }
    return citiesList
      .filter(city => {
        const cityState = city.state || '';
        return cityState.toLowerCase() === farmerState.toLowerCase();
      })
      .map(city => city.cityName || city);
  };

  useEffect(() => {
    if (formData.projectName && formData.projectName._id) {
      loadPlots(formData.projectName._id, plotSearchTerm);
    } else {
      setPlots([]);
      setFormData(prev => ({ ...prev, selectedPlots: [] }));
    }
  }, [formData.projectName, plotSearchTerm]);

  useEffect(() => {
    const rate = parseFloat(formData.ratePerBiswa) || 0;
    const rakba = parseFloat(formData.totalRakba) || 0;
    if (rate && rakba) {
      setFormData(prev => ({ ...prev, purchaseAmount: (rate * rakba).toFixed(2) }));
    }
  }, [formData.ratePerBiswa, formData.totalRakba]);

  useEffect(() => {
    let totalDealAmount = 0;
    let advanceAmount = 0;
    let balanceAmount = 0;

    formData.farmers.forEach(farmer => {
      const totalAmount = parseFloat(farmer.totalAmount) || 0;
      const paidAmount = parseFloat(farmer.paidAmount) || 0;
      const outstandingAmount = parseFloat(farmer.outstandingAmount) || 0;

      totalDealAmount += totalAmount;
      advanceAmount += paidAmount;
      balanceAmount += outstandingAmount;
    });

    setFormData(prev => ({
      ...prev,
      totalDealAmount: totalDealAmount.toFixed(2),
      advanceAmount: advanceAmount.toFixed(2),
      balanceAmount: balanceAmount.toFixed(2)
    }));
  }, [formData.farmers]);

  const isValidMobile = (mobile) => {
    const mobileRegex = /^[6-9]\d{9}$/;
    return mobileRegex.test(mobile);
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isValidAadhaar = (aadhaar) => {
    const aadhaarRegex = /^\d{12}$/;
    return aadhaarRegex.test(aadhaar);
  };

  const isValidPAN = (pan) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return panRegex.test(pan);
  };

  const isValidAccountNumber = (accountNumber) => {
    const accountRegex = /^\d{9,18}$/;
    return accountRegex.test(accountNumber);
  };

  const isValidIFSC = (ifsc) => {
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/i;
    return ifscRegex.test(ifsc);
  };

  const handleFarmerChange = (index, field, value) => {
    const updatedFarmers = [...formData.farmers];
    updatedFarmers[index][field] = value;

    if (field === 'mobileNumber') {
      const mobileError = (value && !isValidMobile(value)) ? 'Mobile number invalid' : '';
      setErrors(prev => ({
        ...prev,
        [`farmer_${index}_mobile`]: mobileError
      }));
    }

    if (field === 'alternateMobile') {
      const altMobileError = (value && !isValidMobile(value)) ? 'Alternate number invalid' : '';
      setErrors(prev => ({
        ...prev,
        [`farmer_${index}_altMobile`]: altMobileError
      }));
    }

    if (field === 'email') {
      const emailError = !isValidEmail(value) && value !== '' ? 'Invalid email address' : '';
      setErrors(prev => ({
        ...prev,
        [`farmer_${index}_email`]: emailError
      }));
    }

    if (field === 'aadhaar') {
      const aadhaarError = !isValidAadhaar(value) && value !== '' ? 'Invalid Aadhaar number (12 digits required)' : '';
      setErrors(prev => ({
        ...prev,
        [`farmer_${index}_aadhaar`]: aadhaarError
      }));
    }

    if (field === 'pan') {
      const panError = !isValidPAN(value) && value !== '' ? 'Invalid PAN number (format: ABCDE1234F)' : '';
      setErrors(prev => ({
        ...prev,
        [`farmer_${index}_pan`]: panError
      }));
    }

    if (field === 'bankAccount') {
      const accountError = !isValidAccountNumber(value) && value !== '' ? 'Invalid Account Number (9-18 digits required)' : '';
      setErrors(prev => ({
        ...prev,
        [`farmer_${index}_account`]: accountError
      }));
    }

    if (field === 'ifscCode') {
      const ifscError = !isValidIFSC(value) && value !== '' ? 'Invalid IFSC Code (format: XXXX0XXXXXX)' : '';
      setErrors(prev => ({
        ...prev,
        [`farmer_${index}_ifsc`]: ifscError
      }));
    }

    if (field === 'vedhanicAnsh' || field === 'rate') {
      const vedhanicAnsh = updatedFarmers[index].vedhanicAnsh === '' ? 0 : parseFloat(updatedFarmers[index].vedhanicAnsh) || 0;
      const rate = updatedFarmers[index].rate === '' ? 0 : parseFloat(updatedFarmers[index].rate) || 0;
      updatedFarmers[index].totalAmount = vedhanicAnsh * rate;

      const totalAmount = updatedFarmers[index].totalAmount === '' ? 0 : parseFloat(updatedFarmers[index].totalAmount) || 0;
      const paidAmount = updatedFarmers[index].paidAmount === '' ? 0 : parseFloat(updatedFarmers[index].paidAmount) || 0;
      updatedFarmers[index].outstandingAmount = totalAmount - paidAmount;
    }

    if (field === 'paidAmount') {
      const totalAmount = updatedFarmers[index].totalAmount === '' ? 0 : parseFloat(updatedFarmers[index].totalAmount) || 0;
      const paidAmount = updatedFarmers[index].paidAmount === '' ? 0 : parseFloat(updatedFarmers[index].paidAmount) || 0;
      updatedFarmers[index].outstandingAmount = totalAmount - paidAmount;
    }

    setFormData(prev => ({ ...prev, farmers: updatedFarmers }));
  };

  const handleFarmerAddressChange = (index, field, value) => {
    const updatedFarmers = [...formData.farmers];
    updatedFarmers[index][field] = value;
    setFormData(prev => ({ ...prev, farmers: updatedFarmers }));
  };

  const handleFarmerBankDetailsChange = (index, field, value) => {
    const updatedFarmers = [...formData.farmers];
    updatedFarmers[index][field] = value;
    setFormData(prev => ({ ...prev, farmers: updatedFarmers }));
  };



  const addFarmer = () => {
    const totalRakba = parseFloat(globalLand.totalRakba) || 0;
    const currentAllocated = formData.farmers.reduce((sum, f) => sum + (parseFloat(f.vedhanicAnsh) || 0), 0);
    const remainingRakba = Math.max(0, totalRakba - currentAllocated);

    if (totalRakba > 0 && remainingRakba <= 0) {
      showConfirm(`Warning: Total Rakba (${totalRakba}) is already fully allocated. Do you want to add another Shahkhatedar with 0 Vedhanic Ansh?`, () => executeAddFarmer(remainingRakba), 'Capacity Warning');
      return;
    }
    executeAddFarmer(remainingRakba);
  };

  const executeAddFarmer = (remainingRakba) => {

    const newFarmer = {
      name: '',
      fullNameHindi: '',
      fatherHusbandName: '',
      mobileNumber: '',
      alternateMobile: '',
      email: '',
      address: globalLand.village || '',
      village: globalLand.village || '',
      post: '',
      tehsil: globalLand.tehsil || '',
      district: globalLand.district || '',
      state: globalLand.state || '',
      pincode: '',
      aadhaar: '',
      pan: '',
      dob: '',
      age: '',
      bankAccount: '',
      ifscCode: '',
      bankName: '',
      branchName: '',
      accountHolderName: '',
      accountType: '',
      cancelledCheque: null,
      sellerType: 'Individual',
      documents: {},
      sellerPhoto: null,
      aarajiNumber: '',
      gataNumber: '',
      unitType: '',
      totalRakba: '',
      unitType: '',
      totalRakba: '',
      vedhanicAnsh: remainingRakba > 0 ? remainingRakba.toFixed(4) : '',
      rate: '',
      totalAmount: '',
      paidAmount: '',
      outstandingAmount: '',
      paymentDate: '',
      paymentMode: '',
      refNumber: ''
    };

    setFormData(prev => ({
      ...prev,
      farmers: [...prev.farmers, newFarmer]
    }));

    setSuccessMessage('Sahkhatedar added with auto-copied address details');
  };

  const removeFarmer = (index) => {
    setFormData(prev => ({
      ...prev,
      farmers: prev.farmers.filter((_, i) => i !== index)
    }));
  };

  const handleFarmerFileUpload = (index, docType, file) => {
    if (!file) return;
    const updatedFarmers = [...formData.farmers];
    updatedFarmers[index].documents[docType] = { name: file.name, size: file.size };
    setFormData(prev => ({ ...prev, farmers: updatedFarmers }));
    setSuccessMessage(`Farmer ${index + 1} ${docType} attached.`);
  };

  const handleLandFileUpload = (docType, file) => {
    if (!file) return;
    setFormData(prev => ({
      ...prev,
      landDocuments: { ...prev.landDocuments, [docType]: { name: file.name } }
    }));
  };

  const handleFarmerDocumentUpload = async (farmerIndex, docType, file) => {
    if (!file) return;

    const uploadKey = `farmer_${farmerIndex}_${docType}`;

    try {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: true }));

      const viewUrl = await uploadImage(file);

      setDocumentUrls(prev => {
        const updatedFarmers = [...prev.farmers];
        updatedFarmers[farmerIndex] = {
          ...updatedFarmers[farmerIndex],
          [docType]: viewUrl
        };
        return { ...prev, farmers: updatedFarmers };
      });

      const updatedFarmers = [...formData.farmers];
      updatedFarmers[farmerIndex].documents[docType] = { name: file.name, size: file.size };
      setFormData(prev => ({ ...prev, farmers: updatedFarmers }));

      setSuccessMessage(`Farmer ${farmerIndex + 1} ${docType} uploaded successfully.`);
    } catch (error) {
      console.error(`Error uploading ${docType}:`, error);
      setSuccessMessage(`Failed to upload ${docType}: ${error.message}`);
    } finally {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: false }));
    }
  };

  const handleLandDocumentUpload = async (docType, file) => {
    if (!file) return;

    const uploadKey = `land_${docType}`;

    try {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: true }));

      const viewUrl = await uploadImage(file);

      setDocumentUrls(prev => ({
        ...prev,
        land: {
          ...prev.land,
          [docType]: viewUrl
        }
      }));

      setFormData(prev => ({
        ...prev,
        landDocuments: { ...prev.landDocuments, [docType]: { name: file.name } }
      }));

      setSuccessMessage(`${docType} uploaded successfully.`);
    } catch (error) {
      console.error(`Error uploading ${docType}:`, error);
      setSuccessMessage(`Failed to upload ${docType}: ${error.message}`);
    } finally {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: false }));
    }
  };

  const handleCancelledChequeUpload = async (farmerIndex, file) => {
    if (!file) return;

    const uploadKey = `farmer_${farmerIndex}_cancelledCheque`;

    try {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: true }));

      const viewUrl = await uploadImage(file);

      setDocumentUrls(prev => {
        const updatedFarmers = [...prev.farmers];
        updatedFarmers[farmerIndex] = {
          ...updatedFarmers[farmerIndex],
          cancelledChequeUrl: viewUrl
        };
        return { ...prev, farmers: updatedFarmers };
      });

      const updatedFarmers = [...formData.farmers];
      updatedFarmers[farmerIndex].cancelledCheque = { name: file.name, size: file.size };
      setFormData(prev => ({ ...prev, farmers: updatedFarmers }));

      setSuccessMessage(`Farmer ${farmerIndex + 1} cancelled cheque uploaded successfully.`);
    } catch (error) {
      console.error('Error uploading cancelled cheque:', error);
      setSuccessMessage(`Failed to upload cancelled cheque: ${error.message}`);
    } finally {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: false }));
    }
  };

  const handleFarmerOtherDocumentUpload = async (farmerIndex, file) => {
    if (!file) return;

    const uploadKey = `farmer_${farmerIndex}_otherDocument`;

    try {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: true }));

      const viewUrl = await uploadImage(file);

      setDocumentUrls(prev => {
        const updatedFarmers = [...prev.farmers];
        updatedFarmers[farmerIndex] = {
          ...updatedFarmers[farmerIndex],
          otherDocuments: viewUrl
        };
        return { ...prev, farmers: updatedFarmers };
      });

      const updatedFarmers = [...formData.farmers];
      updatedFarmers[farmerIndex].otherDocument = { name: file.name, size: file.size };
      setFormData(prev => ({ ...prev, farmers: updatedFarmers }));

      setSuccessMessage(`Farmer ${farmerIndex + 1} other document uploaded successfully.`);
    } catch (error) {
      console.error('Error uploading other document:', error);
      setSuccessMessage(`Failed to upload other document: ${error.message}`);
    } finally {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: false }));
    }
  };

  const handleLandOtherDocumentUpload = async (file) => {
    if (!file) return;

    const uploadKey = `land_otherDocument`;

    try {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: true }));

      const viewUrl = await uploadImage(file);

      setDocumentUrls(prev => ({
        ...prev,
        land: {
          ...prev.land,
          otherDocuments: viewUrl
        }
      }));

      setFormData(prev => ({ ...prev, landOtherDocument: { name: file.name, size: file.size } }));

      setSuccessMessage(`Land other document uploaded successfully.`);
    } catch (error) {
      console.error('Error uploading land other document:', error);
      setSuccessMessage(`Failed to upload land other document: ${error.message}`);
    } finally {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: false }));
    }
  };

  const handlePaymentAttachmentUpload = async (file) => {
    if (!file) return;

    const uploadKey = `paymentAttachment`;

    try {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: true }));

      const viewUrl = await uploadImage(file);
      setDocumentUrls(prev => ({
        ...prev,
        paymentAttachment: viewUrl
      }));

      setFormData(prev => ({ ...prev, paymentAttachment: { name: file.name, size: file.size } }));

      setSuccessMessage(`Payment attachment uploaded successfully.`);
    } catch (error) {
      console.error('Error uploading payment attachment:', error);
      setSuccessMessage(`Failed to upload payment attachment: ${error.message}`);
    } finally {
      setUploadingDocuments(prev => ({ ...prev, [uploadKey]: false }));
    }
  };

  const areRequiredFieldsFilled = () => {
    if (!formData.projectName || !formData.projectName._id) {
      return false;
    }

    if (!formData.selectedPlots || formData.selectedPlots.length === 0) {
      return false;
    }

    if (!globalLand.khataNumber || !globalLand.gataNumber || !globalLand.unit || !globalLand.totalRakba) {
      return false;
    }

    for (const farmer of formData.farmers) {
      if (!farmer.fullNameHindi || !farmer.mobileNumber || !farmer.aadhaar) {
        return false;
      }

      if (!isValidMobile(farmer.mobileNumber)) {
        return false;
      }

      if (farmer.aadhaar.length !== 12) {
        return false;
      }

      // PAN is optional now
      /* if (farmer.pan.length !== 10) {
        return false;
      } */
    }

    return true;
  };

  const submitForm = async (formData) => {
    let hasErrors = false;
    const newErrors = {};

    if (!formData.projectName || !formData.projectName._id) {
      newErrors.project = 'Project is required';
      hasErrors = true;
    }

    if (!formData.selectedPlots || formData.selectedPlots.length === 0) {
      newErrors.plots = 'At least one plot is required';
      hasErrors = true;
    }

    if (!globalLand.khataNumber) {
      newErrors.khataNumber = 'Khata Number is required';
      hasErrors = true;
    }

    if (!globalLand.gataNumber) {
      newErrors.gataNumber = 'Gata / Khasara Number is required';
      hasErrors = true;
    }

    if (!globalLand.unit) {
      newErrors.unit = 'Unit is required';
      hasErrors = true;
    }

    if (!globalLand.totalRakba) {
      newErrors.totalRakba = 'Total Rakba / Area is required';
      hasErrors = true;
    }



    formData.farmers.forEach((farmer, index) => {
      if (!farmer.fullNameHindi) {
        newErrors[`farmer_${index}_fullNameHindi`] = 'Shahkhatedar Full Name is required';
        hasErrors = true;
      }

      if (!farmer.mobileNumber) {
        newErrors[`farmer_${index}_mobile`] = 'Mobile number is required';
        hasErrors = true;
      }

      if (!farmer.aadhaar) {
        newErrors[`farmer_${index}_aadhaar`] = 'Aadhaar number is required';
        hasErrors = true;
      }

      if (!farmer.vedhanicAnsh) {
        newErrors[`farmer_${index}_vedhanicAnsh`] = 'Vedhanic Ansh is required';
        hasErrors = true;
      }

      if (!farmer.rate) {
        newErrors[`farmer_${index}_rate`] = 'Rate per Unit is required';
        hasErrors = true;
      }

      if (!farmer.aarajiNumber || farmer.aarajiNumber.toString().trim() === '') {
        newErrors[`farmer_${index}_aarajiNumber`] = 'Aaraji Number is required';
        hasErrors = true;
      }

      const paidAmount = parseFloat(farmer.paidAmount || 0);
      if (paidAmount > 0) {
        if (!farmer.paymentDate) {
          newErrors[`farmer_${index}_paymentDate`] = 'Payment Date is required when paid amount > 0';
          hasErrors = true;
        }

        if (!farmer.paymentMode) {
          newErrors[`farmer_${index}_paymentMode`] = 'Payment Mode is required when paid amount > 0';
          hasErrors = true;
        }

        if (!farmer.refNumber) {
          newErrors[`farmer_${index}_refNumber`] = 'Reference Number is required when paid amount > 0';
          hasErrors = true;
        }
      }

      if (farmer.mobileNumber && !isValidMobile(farmer.mobileNumber)) {
        newErrors[`farmer_${index}_mobile`] = 'Mobile number invalid';
        hasErrors = true;
      }

      if (farmer.alternateMobile && !isValidMobile(farmer.alternateMobile)) {
        newErrors[`farmer_${index}_altMobile`] = 'Alternate number invalid';
        hasErrors = true;
      }

      if (farmer.aadhaar && !isValidAadhaar(farmer.aadhaar)) {
        newErrors[`farmer_${index}_aadhaar`] = 'Invalid Aadhaar number (12 digits required)';
        hasErrors = true;
      }

      if (farmer.pan && !isValidPAN(farmer.pan)) {
        newErrors[`farmer_${index}_pan`] = 'Invalid PAN number (format: ABCDE1234F)';
        hasErrors = true;
      }

      if (farmer.email && !isValidEmail(farmer.email)) {
        newErrors[`farmer_${index}_email`] = 'Invalid email address';
        hasErrors = true;
      }
    });

    const totalAllocated = formData.farmers.reduce((sum, f) => sum + (parseFloat(f.vedhanicAnsh) || 0), 0);
    const totalGlobal = parseFloat(globalLand.totalRakba) || 0;

    if (Math.abs(totalAllocated - totalGlobal) > 0.01 && totalGlobal > 0) {
      newErrors.totalRakba = `Sum of Vedhanic Ansh (${totalAllocated.toFixed(4)}) must match Total Rakba (${totalGlobal})`;
      hasErrors = true;
    }

    setErrors(newErrors);

    if (hasErrors) {
      showAlert('Please fix validation errors before submitting.', 'warning', 'Validation Error');
      setTimeout(() => {
        const firstErrorEl = document.querySelector('.Mui-error, [aria-invalid="true"]');
        if (firstErrorEl) {
          firstErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const input = firstErrorEl.querySelector('input, select, textarea') || firstErrorEl;
          if (input && typeof input.focus === 'function') {
            input.focus();
          }
        }
      }, 100);
      return;
    }

    try {
      setIsSubmitting(true);

      const payload = {
        projectId: formData.projectName?._id || null,
        plotNo: [],
        plotId: [],
        owners: formData.farmers.map((farmer, index) => ({
          farmerName: farmer.fullNameHindi || farmer.name || '',
          sellerType: farmer.sellerType || 'Individual',
          fatherName: farmer.fatherHusbandName || '',
          mobile: farmer.mobileNumber || '',
          alternateMobile: farmer.alternateMobile || '',
          email: farmer.email || '',
          aadhaarNumber: farmer.aadhaar || '',
          panNumber: farmer.pan || '',
          dob: farmer.dob || '',
          village: farmer.village || '',
          post: farmer.post || '',
          tehsil: farmer.tehsil || '',
          district: farmer.district || '',
          state: farmer.state || '',
          city: farmer.district || '',
          pincode: farmer.pincode || '',
          address: farmer.address || '',

          bankName: farmer.bankName || '',
          branchName: farmer.branchName || '',
          accountHolderName: farmer.accountHolderName || '',
          accountNumber: farmer.bankAccount || '',
          ifscCode: farmer.ifscCode || '',
          accountType: farmer.accountType || '',
          cancelledChequeUrl: documentUrls.farmers[index]?.cancelledChequeUrl || '',
          aadharFront: documentUrls.farmers[index]?.aadharFront || '',
          aadharBack: documentUrls.farmers[index]?.aadharBack || '',
          pan: documentUrls.farmers[index]?.pan || '',
          voterIdFront: documentUrls.farmers[index]?.voterIdFront || '',
          voterIdBack: documentUrls.farmers[index]?.voterIdBack || '',
          signature: documentUrls.farmers[index]?.signature || '',
          sellerPhoto: documentUrls.farmers[index]?.sellerPhoto || '',
          otherDocuments: documentUrls.farmers[index]?.otherDocuments || '',
          aarajiNumber: farmer.aarajiNumber ? farmer.aarajiNumber.toString().split(',').filter(v => v.trim()) : [],
          gataNumber: farmer.gataNumber ? farmer.gataNumber.toString().split(',').filter(v => v.trim()) : [],
          unitType: farmer.unitType || '',
          totalRakba: parseFloat(farmer.totalRakba) || 0,
          khataNumber: formData.khataNo || '',
          vedhanicAnsh: parseFloat(farmer.vedhanicAnsh) || 0,
          ratePerUnit: parseFloat(farmer.rate) || 0,
          paidAmount: parseFloat(farmer.paidAmount) || 0,
          paymentMode: farmer.paymentMode || '',
          referenceNumber: farmer.refNumber || '',
          totalPayment: parseFloat(farmer.totalAmount) || 0,
          outstandingAmount: parseFloat(farmer.outstandingAmount) || 0,
        })),
        landDetails: {
          state: formData.state || globalLand.state || '',
          district: formData.district || globalLand.district || '',
          tehsil: formData.tehsil || globalLand.tehsil || '',
          village: formData.village || globalLand.village || '',
          khataNumber: formData.khataNo || globalLand.khataNumber || '',
          gataOrKhasraNumber: formData.gataNo || globalLand.gataNumber || '',

          landType: formData.landType || globalLand.landType || '',
          landUsage: formData.landUsage || globalLand.landUsage || '',

          totalRakba: formData.totalRakba ? parseFloat(formData.totalRakba) : 0,
          rateUnit: formData.unit || globalLand.unit || '',
          ratePerUnit: formData.ratePerUnit ? parseFloat(formData.ratePerUnit) : 0,
          totalAmount: formData.totalDealAmount ? parseFloat(formData.totalDealAmount) : 0,
        },
        boundaries: {
          east: formData.eastBoundary || '',
          west: formData.westBoundary || '',
          north: formData.northBoundary || '',
          south: formData.southBoundary || '',
        },
        legalStatus: {
          legalStatus: formData.legalStatus || 'Clear',
          encumbrance: formData.encumbranceStatus === 'Free' ? false : true,
          courtCase: formData.courtCase === 'Yes',
          bankMortgage: formData.bankMortgage === 'Yes',
          leaseExists: formData.leaseAgreement === 'Yes',
        },
        purchaseAgreement: {
          agreementType: formData.agreementType || 'Agreement to Sell',
          totalDealAmount: formData.totalDealAmount ? parseFloat(formData.totalDealAmount) : 0,
          advanceAmount: formData.advanceAmount ? parseFloat(formData.advanceAmount) : 0,
          stampDutyValue: formData.stampDutyValue ? parseFloat(formData.stampDutyValue) : 0,
          circleRate: formData.circleRate ? parseFloat(formData.circleRate) : 0,
          registryDate: formData.registryDate || '',
          mutationDate: formData.mutationDate || '',
          brokerName: formData.brokerName || ''
        },
        landDocuments: {
          ...(documentUrls.land || {}),
          paymentAttachment: documentUrls.paymentAttachment || ''
        }
      };

      if (Array.isArray(formData.selectedPlots)) {
        formData.selectedPlots.forEach(plot => {
          if (plot && plot._id) {
            payload.plotNo.push(plot.plotName);
            payload.plotId.push(plot._id);
          }
        });
      } else if (formData.selectedPlots && formData.selectedPlots._id) {
        payload.plotNo.push(formData.selectedPlots.plotName);
        payload.plotId.push(formData.selectedPlots._id);
      }

      const result = await createLandOwnership(payload);

      if (result.success) {
        showAlert(result.message || 'Land ownership record created successfully', 'success', 'Success');
        return result;
      } else {
        throw new Error(result.message || 'Failed to create purchase');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSuccessMessage(`Error: ${error.message}`);
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  const loadProjects = async (pageNum = 1, reset = false) => {
    if (loadingProjects) return;

    setLoadingProjects(true);
    try {
      const response = await getProjectsPaginated({
        page: pageNum,
        limit: 10
      });

      const projectsData = response.data || [];
      const extraData = response.extra || {};
      const totalProjects = extraData.total || 0;

      if (reset) {
        setProjects(projectsData);
        setPage(1);
      } else {
        setProjects(prev => [...prev, ...projectsData]);
        setPage(pageNum);
      }

      setHasMore(projectsData.length > 0 && (pageNum * 10) < totalProjects);
    } catch (error) {
      console.error('Error loading projects:', error);
      setHasMore(false);
    } finally {
      setLoadingProjects(false);
    }
  };

  const loadPlots = async (projectId, search) => {
    if (!projectId) {
      setPlots([]);
      return;
    }

    setLoadingPlots(true);
    try {
      const response = await getPlotsByProject(
        projectId,
        'Plot',
        undefined,
        undefined,
        1,
        10,
        search,
        true
      );

      const inventories = Array.isArray(response.inventories) ? response.inventories : [];

      const formattedPlots = inventories.map((plot, index) => {
        const plotName = plot.plotName || '';
        const normalizedPlotName = plotName.replace(/^P-/, 'Plot-');
        const plotNo = normalizedPlotName || `Plot-${index + 1}` || '';

        return {
          _id: plot._id,
          plotNo: plotNo,
          plotName: plotName || plotNo,
          totalSize: plot.totalSize || 0,
          status: (plot.status || 'select status').toLowerCase(),
          w1: plot.width || 0,
          l1: plot.length || 0,
          facing: plot.facing || '',
          pricePerSqFt: plot.pricePerSqFt || 0,
          amount: plot.amount || 0,
          guidelineValue: plot.guidelineValue || 0,
          companyDiscountPercent: plot.companyDiscountPercent || 0,
          remark: plot.remark || '',
          isEdit: plot.isEdit !== undefined ? plot.isEdit : true,
        };
      });

      setPlots(formattedPlots);
    } catch (error) {
      console.error('Error loading plots:', error);
      setPlots([]);
    } finally {
      setLoadingPlots(false);
    }
  };

  const handleScroll = useCallback((event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;

    if (scrollPercentage >= 70 && !loadingProjects && hasMore) {
      loadProjects(page + 1, false);
    }
  }, [page, loadingProjects, hasMore]);

  const filteredProjects = projects.filter(project =>
    project.projectName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    project.developerName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const farmerDocTypes = ['Aadhaar Front', 'Aadhaar Back', 'PAN Card', 'Voter ID Front / Ration Card Front (optional)', 'Voter ID Back / Ration Card Back (optional)', 'Photo of Seller', 'Signature (scan/photo)'];
  const landDocTypes = ['Khatauni Certificate', 'Purchase Agreement', 'Land Revenue Receipt'];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, justifyContent: 'space-between', gap: 2 }}>
        <Box>
          <Breadcrumbs sx={{ mb: 1 }}>
            <Link underline="hover" color="inherit" sx={{ cursor: 'pointer' }} onClick={onBack}>purchase</Link>
            <Typography color="text.primary">{editMode ? 'Edit' : 'New Entry'}</Typography>
          </Breadcrumbs>
          <Typography variant="h4" fontWeight="bold" color="primary.main">Land Purchase Entry</Typography>
        </Box>
        <Button variant="outlined" startIcon={<ArrowBack />} onClick={onBack} sx={{ width: { xs: '100%', sm: 'auto' } }}>Back to List</Button>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom><Business color="primary" sx={{ mr: 1 }} />Project & Plots</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Autocomplete
                    options={filteredProjects}
                    value={formData.projectName}
                    onChange={(e, v) => {
                      setFormData({ ...formData, projectName: v, selectedPlots: [] });
                      setPlots([]);
                      setPlotSearchTerm('');
                    }}
                    getOptionLabel={(option) => option.projectName || ''}
                    isOptionEqualToValue={(option, value) =>
                      option._id === value?._id || option.projectName === value
                    }
                    loading={loadingProjects}
                    onInputChange={(event, newInputValue) => {
                      setSearchTerm(newInputValue || '');
                    }}
                    ListboxProps={{
                      onScroll: handleScroll,
                      style: { maxHeight: 200 }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Project Name"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingProjects ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                        error={!!errors.project}
                        helperText={errors.project}
                        required
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <Typography variant="body1" fontWeight="medium">
                            {option.projectName}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {option.developerName} • {option.projectType}
                          </Typography>
                        </Box>
                      </li>
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Autocomplete
                    multiple
                    options={Array.from(new window.Map([...plots, ...(Array.isArray(formData.selectedPlots) ? formData.selectedPlots : [])].map(item => [item._id, item])).values())}
                    value={Array.isArray(formData.selectedPlots) ? formData.selectedPlots : []}
                    onChange={(e, newValue) => setFormData({ ...formData, selectedPlots: newValue })}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason === 'input') {
                        setPlotSearchTerm(newInputValue || '');
                      } else if (reason === 'clear') {
                        setPlotSearchTerm('');
                      }
                    }}
                    getOptionLabel={(option) => option.plotNo || option.plotName || ''}
                    isOptionEqualToValue={(option, value) =>
                      option._id === value._id
                    }
                    required
                    loading={loadingPlots}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Plot Numbers"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadingPlots ? <CircularProgress color="inherit" size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                        disabled={!formData.projectName}
                        error={!!errors.plots}
                        helperText={errors.plots}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option._id}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                          <Typography variant="body1" fontWeight="medium">
                            {option.plotNo || option.plotName}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {option.status} • {option.totalSize} sq.ft
                          </Typography>
                        </Box>
                      </li>
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          label={option.plotNo || option.plotName}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                <Map sx={{ mr: 1 }} color="primary" /> Global Land Details
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    label="State"
                    select
                    fullWidth
                    value={globalLand.state}
                    onChange={(e) => {
                      setGlobalLand({ ...globalLand, state: e.target.value });
                      setGlobalLand(prev => ({ ...prev, district: '' }));
                    }}
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                  >
                    {statesList.map((state) => (
                      <MenuItem key={state.id || state.value || state} value={state.value || state}>
                        {state.name || state}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    label="District"
                    select
                    fullWidth
                    value={globalLand.district}
                    onChange={(e) => setGlobalLand({ ...globalLand, district: e.target.value })}
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                    disabled={!globalLand.state || globalLand.state.trim() === ''}
                    helperText={!globalLand.state ? "Please select a state first" : ""}
                  >
                    <MenuItem value="__add_city__" sx={{ color: "#1976d2", fontWeight: 500 }}>
                      ➕ Add New City
                    </MenuItem>
                    {getCityOptions(globalLand.state).map((city) => (
                      <MenuItem key={city} value={city}>
                        {city}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField fullWidth label="Tehsil"
                    value={globalLand.tehsil}
                    onChange={(e) => setGlobalLand({ ...globalLand, tehsil: e.target.value })}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField fullWidth label="Village / Town / Mauja"
                    value={globalLand.village}
                    onChange={(e) => setGlobalLand({ ...globalLand, village: e.target.value })}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField fullWidth label="Khata Number"
                    value={globalLand.khataNumber}
                    onChange={(e) => setGlobalLand({ ...globalLand, khataNumber: e.target.value })}
                    required
                    error={!!errors.khataNumber}
                    helperText={errors.khataNumber}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField fullWidth label="Gata / Khasara Number "
                    value={globalLand.gataNumber}
                    onChange={(e) => setGlobalLand({ ...globalLand, gataNumber: e.target.value })}
                    required
                    error={!!errors.gataNumber}
                    helperText={errors.gataNumber}
                  />
                </Grid>



                <Grid item xs={12} md={4}>
                  <TextField select fullWidth label="Unit "
                    value={globalLand.unit}
                    onChange={(e) => setGlobalLand({ ...globalLand, unit: e.target.value })}
                    required
                    error={!!errors.unit}
                    helperText={errors.unit}
                    SelectProps={{
                      native: false,
                    }}
                    disabled={loadingUnitTypes}
                  >
                    {loadingUnitTypes ? (
                      <MenuItem value="" disabled>
                        Loading...
                      </MenuItem>
                    ) : (
                      unitTypes.map((unitType) => (
                        <MenuItem key={unitType.id} value={unitType.name}>
                          {unitType.name}
                        </MenuItem>
                      ))
                    )}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Total Rakba / Area"
                    value={globalLand.totalRakba}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || /^\d*\.?\d*$/.test(value)) {
                        setGlobalLand({ ...globalLand, totalRakba: value });
                      }
                    }}
                    required
                    error={!!errors.totalRakba}
                    helperText={errors.totalRakba}
                    inputProps={{
                      inputMode: "decimal"
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField select fullWidth label="Land Type"
                    value={globalLand.landType}
                    onChange={(e) => setGlobalLand({ ...globalLand, landType: e.target.value })}
                    SelectProps={{
                      native: false,
                    }}
                    disabled={loadingLandTypes}
                    error={!!errors.landType}
                    helperText={errors.landType}
                  >
                    {loadingLandTypes ? (
                      <MenuItem value="" disabled>
                        Loading...
                      </MenuItem>
                    ) : (
                      landTypes.map((landType) => (
                        <MenuItem key={landType.id} value={landType.name}>
                          {landType.name}
                        </MenuItem>
                      ))
                    )}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField select fullWidth label="Land Usage"
                    value={globalLand.landUsage}
                    onChange={(e) => setGlobalLand({ ...globalLand, landUsage: e.target.value })}
                    SelectProps={{
                      native: false,
                    }}
                    disabled={loadingLandUsages}
                    error={!!errors.landUsage}
                    helperText={errors.landUsage}
                  >
                    {loadingLandUsages ? (
                      <MenuItem value="" disabled>
                        Loading...
                      </MenuItem>
                    ) : (
                      landUsages.map((landUsage) => (
                        <MenuItem key={landUsage.id} value={landUsage.name}>
                          {landUsage.name}
                        </MenuItem>
                      ))
                    )}
                  </TextField>
                </Grid>

              </Grid>
            </CardContent>
          </Card>


          <Box sx={{ mb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Typography variant="h5" fontWeight="bold">Farmer Details & KYC</Typography>
            </Box>

            {formData.farmers.map((farmer, index) => (
              <Card
                key={index}
                variant="outlined"
                sx={{
                  mb: 3,
                  borderRadius: 2,
                  borderLeft: '6px solid #1976d2'
                }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6" color="primary">Shahkhatedar {index + 1}</Typography>
                    {formData.farmers.length > 1 && (
                      <IconButton onClick={() => removeFarmer(index)} color="error"><DeleteIcon /></IconButton>
                    )}
                  </Box>

                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <TextField
                        select
                        fullWidth
                        label="Seller Type *"
                        value={farmer.sellerType || ''}
                        onChange={(e) => handleFarmerChange(index, 'sellerType', e.target.value)}
                      >
                        <MenuItem value="Farmer">Farmer</MenuItem>
                        <MenuItem value="Individual">Individual</MenuItem>
                        <MenuItem value="Family (Joint)">Family (Joint)</MenuItem>
                        <MenuItem value="Trust / Society">Trust / Society</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Full Name"
                        required
                        value={farmer.fullNameHindi}
                        onChange={(e) => handleFarmerChange(index, 'fullNameHindi', e.target.value)}
                        error={!!errors[`farmer_${index}_fullNameHindi`]}
                        helperText={errors[`farmer_${index}_fullNameHindi`]}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}><TextField fullWidth label="Father / Husband Name" value={farmer.fatherHusbandName} onChange={(e) => handleFarmerChange(index, 'fatherHusbandName', e.target.value)} /></Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Mobile Number"
                        required
                        value={farmer.mobileNumber}
                        onChange={(e) => {
                          const value = (e.target.value || '').replace(/\D/g, '').slice(0, 10);
                          handleFarmerChange(index, 'mobileNumber', value);
                        }}
                        error={!!errors[`farmer_${index}_mobile`]}
                        helperText={errors[`farmer_${index}_mobile`] || "10 digits (starts with 6-9)"}
                        inputProps={{
                          maxLength: 10,
                          inputMode: 'numeric'
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Alternate Mobile"
                        value={farmer.alternateMobile}
                        onChange={(e) => {
                          const value = (e.target.value || '').replace(/\D/g, '').slice(0, 10);
                          handleFarmerChange(index, 'alternateMobile', value);
                        }}
                        error={!!errors[`farmer_${index}_altMobile`]}
                        helperText={errors[`farmer_${index}_altMobile`] || "Optional (10 digits)"}
                        inputProps={{
                          maxLength: 10,
                          inputMode: 'numeric'
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}><TextField fullWidth label="Email" value={farmer.email} onChange={(e) => handleFarmerChange(index, 'email', e.target.value)} error={!!errors[`farmer_${index}_email`]} helperText={errors[`farmer_${index}_email`]} /></Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Aadhaar Number"
                        required
                        value={farmer.aadhaar}
                        onChange={(e) => {
                          const value = (e.target.value || '').replace(/\D/g, '').slice(0, 12);
                          handleFarmerChange(index, 'aadhaar', value);
                        }}
                        error={!!errors[`farmer_${index}_aadhaar`]}
                        helperText={errors[`farmer_${index}_aadhaar`]}
                        inputProps={{
                          maxLength: 12,
                          inputMode: 'numeric'
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="PAN Number"
                        // required
                        value={farmer.pan}
                        onChange={(e) => {
                          const value = (e.target.value || '').toUpperCase().slice(0, 10);
                          handleFarmerChange(index, 'pan', value);
                        }}
                        error={!!errors[`farmer_${index}_pan`]}
                        helperText={errors[`farmer_${index}_pan`]}
                        inputProps={{
                          maxLength: 10,
                          style: { textTransform: 'uppercase', padding: 16 }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}><TextField fullWidth label="DOB" type="date" value={farmer.dob} onChange={(e) => handleFarmerChange(index, 'dob', e.target.value)} InputLabelProps={{ shrink: true }} inputProps={{ style: { padding: 16 } }} /></Grid>

                    <Grid item xs={12}>
                      <Typography variant="subtitle2" sx={{ mt: 1, mb: 1 }}>Address Details</Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <TextField
                            fullWidth
                            multiline
                            rows={2}
                            label="Address"
                            value={farmer.address}
                            onChange={(e) => handleFarmerAddressChange(index, 'address', e.target.value)}
                            variant="outlined"
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            select
                            fullWidth
                            label="State"
                            value={farmer.state || ''}
                            onChange={(e) => {
                              handleFarmerAddressChange(index, 'state', e.target.value);
                              handleFarmerAddressChange(index, 'district', '');
                            }}
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                          >
                            {statesList.map((state, stateIndex) => {
                              const stateValue = typeof state === 'string' ? state : (state.value || state.stateName || state.name || state);
                              const stateLabel = typeof state === 'string' ? state : (state.name || state.stateName || state.value || state);
                              const stateKey = typeof state === 'string' ? `state-${stateIndex}` : (state.id || state._id || stateValue || `state-${stateIndex}`);

                              return (
                                <MenuItem key={stateKey} value={stateValue}>
                                  {stateLabel}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            select
                            fullWidth
                            label="City"
                            value={farmer.district || ''}
                            onChange={(e) => {
                              if (e.target.value === '__add_city__') {
                                setAddCityDialogOpen(true);
                                setNewCityName('');
                                setCurrentFarmerIndex(index);
                              } else {
                                handleFarmerAddressChange(index, 'district', e.target.value);
                              }
                            }}
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                            disabled={!farmer.state || farmer.state.trim() === ''}
                            helperText={!farmer.state ? "Please select a state first" : ""}
                          >
                            <MenuItem value="__add_city__" sx={{ color: "#1976d2", fontWeight: 500 }}>
                              ➕ Add New City
                            </MenuItem>
                            {getCityOptions(farmer.state).map((city) => (
                              <MenuItem key={city} value={city}>
                                {city}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            label="Pincode"
                            value={farmer.pincode}
                            onChange={(e) => {
                              const value = (e.target.value || '').replace(/\D/g, '').slice(0, 6);
                              handleFarmerAddressChange(index, 'pincode', value);
                            }}
                            variant="outlined"
                            inputProps={{
                              maxLength: 6,
                              inputMode: 'numeric',
                              pattern: '[0-9]*',
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="subtitle2" sx={{ mt: 1, mb: 1 }}>Bank Details</Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          <TextField
                            label="Bank Name"
                            select
                            fullWidth
                            value={farmer.bankName}
                            onChange={(e) => handleFarmerBankDetailsChange(index, 'bankName', e.target.value)}
                            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
                          >
                            {banksList.map((bank) => (
                              <MenuItem key={bank.id} value={bank.value || bank.bankName || bank.name || bank}>
                                {bank.name || bank.bankName || bank.value || bank}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}><TextField fullWidth label="Branch Name" value={farmer.branchName} onChange={(e) => handleFarmerBankDetailsChange(index, 'branchName', e.target.value)} /></Grid>
                        <Grid item xs={12} md={4}><TextField fullWidth label="Account Holder Name" value={farmer.accountHolderName} onChange={(e) => handleFarmerBankDetailsChange(index, 'accountHolderName', e.target.value)} /></Grid>
                        <Grid item xs={12} md={4}><TextField fullWidth label="Account Number" value={farmer.bankAccount} onChange={(e) => handleFarmerBankDetailsChange(index, 'bankAccount', e.target.value)} error={!!errors[`farmer_${index}_account`]} helperText={errors[`farmer_${index}_account`]} /></Grid>
                        <Grid item xs={12} md={4}><TextField fullWidth label="IFSC Code" value={farmer.ifscCode} onChange={(e) => handleFarmerBankDetailsChange(index, 'ifscCode', e.target.value)} error={!!errors[`farmer_${index}_ifsc`]} helperText={errors[`farmer_${index}_ifsc`]} /></Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            select
                            fullWidth
                            label="Account Type"
                            value={farmer.accountType || ''}
                            onChange={(e) => handleFarmerBankDetailsChange(index, 'accountType', e.target.value)}
                          >
                            <MenuItem value="Savings">Savings</MenuItem>
                            <MenuItem value="Current">Current</MenuItem>
                          </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Button
                            component="label"
                            variant="outlined"
                            fullWidth
                            startIcon={uploadingDocuments[`farmer_${index}_cancelledCheque`] ? <CircularProgress size={20} /> : <CloudUpload />}
                            color={documentUrls.farmers[index]?.cancelledChequeUrl ? "success" : "primary"}
                            disabled={uploadingDocuments[`farmer_${index}_cancelledCheque`]}
                          >
                            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                              {documentUrls.farmers[index]?.cancelledChequeUrl
                                ? `Cancelled Cheque: Uploaded`
                                : uploadingDocuments[`farmer_${index}_cancelledCheque`]
                                  ? "Uploading..."
                                  : "Upload Cancelled Cheque"}
                            </Box>
                            {documentUrls.farmers[index]?.cancelledChequeUrl && (
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  openImagePreview(documentUrls.farmers[index].cancelledChequeUrl, 'Cancelled Cheque');
                                }}
                                sx={{ ml: 1 }}
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                            )}
                            <input
                              type="file"
                              hidden
                              accept="image/*,application/pdf"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  handleCancelledChequeUpload(index, file);
                                }
                              }}
                            />
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography variant="subtitle2" sx={{ mt: 1, mb: 1 }}>Shahkhatedar {index + 1} KYC Documents:</Typography>
                      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                        {farmerDocTypes.map(doc => {
                          const docKeyMap = {
                            'Aadhaar Front': ['aadharFront'],
                            'Aadhaar Back': ['aadharBack'],
                            'PAN Card': ['pan'],
                            'Voter ID Front / Ration Card Front (optional)': ['voterIdFront'],
                            'Voter ID Back / Ration Card Back (optional)': ['voterIdBack'],
                            'Photo of Seller': ['sellerPhoto'],
                            'Signature (scan/photo)': ['signature']
                          };

                          const docKeys = docKeyMap[doc] || [doc.replace(/\s+/g, '').toLowerCase()];
                          const isUploaded = docKeys.some(key => documentUrls.farmers[index]?.[key]);
                          const isUploading = docKeys.some(key => uploadingDocuments[`farmer_${index}_${key}`]);

                          return (
                            <Button
                              key={doc}
                              component="label"
                              variant="outlined"
                              size="small"
                              startIcon={isUploading ? <CircularProgress size={20} /> : <CloudUpload />}
                              color={isUploaded ? "success" : "primary"}
                              disabled={isUploading}
                              sx={{
                                minWidth: 200,
                                width: { xs: '100%', sm: 297.3 },
                                justifyContent: 'flex-start',
                                textTransform: 'none',
                                position: 'relative'
                              }}
                            >
                              <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                                {isUploaded
                                  ? `${doc} uploaded`
                                  : isUploading
                                    ? "Uploading..."
                                    : `Upload ${doc}`}
                              </Box>

                              {isUploaded && (
                                <IconButton
                                  size="small"
                                  color="primary"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const url = docKeys.map(key => documentUrls.farmers[index]?.[key]).find(u => u);
                                    openImagePreview(url, doc);
                                  }}
                                  sx={{ ml: 1 }}
                                >
                                  <Visibility fontSize="small" />
                                </IconButton>
                              )}
                              <input
                                type="file"
                                hidden
                                accept="image/*,application/pdf"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    if (doc === 'Aadhaar Front') {
                                      handleFarmerDocumentUpload(index, 'aadharFront', file);
                                    } else if (doc === 'Aadhaar Back') {
                                      handleFarmerDocumentUpload(index, 'aadharBack', file);
                                    } else if (doc === 'PAN Card') {
                                      handleFarmerDocumentUpload(index, 'pan', file);
                                    } else if (doc === 'Voter ID Front / Ration Card Front (optional)') {
                                      handleFarmerDocumentUpload(index, 'voterIdFront', file);
                                    } else if (doc === 'Voter ID Back / Ration Card Back (optional)') {
                                      handleFarmerDocumentUpload(index, 'voterIdBack', file);
                                    } else if (doc === 'Photo of Seller') {
                                      handleFarmerDocumentUpload(index, 'sellerPhoto', file);
                                    } else if (doc === 'Signature (scan/photo)') {
                                      handleFarmerDocumentUpload(index, 'signature', file);
                                    } else {
                                      handleFarmerDocumentUpload(index, docKeys[0], file);
                                    }
                                  }
                                }}
                              />
                            </Button>
                          );
                        })}
                      </Box>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} mt={2}>

                    <Grid item xs={12}>
                      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
                        <Map color="primary" sx={{ mr: 1 }} />
                        Shahkhatedar Land Details
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Autocomplete
                        multiple
                        freeSolo
                        options={[]}
                        value={farmer.aarajiNumber ? farmer.aarajiNumber.toString().split(',').filter(x => x.trim() !== '') : []}
                        onChange={(event, newValue) => {
                          handleFarmerChange(index, 'aarajiNumber', newValue.join(','));
                        }}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Aaraji Number(s) *"
                            placeholder="Type & Press Enter"
                            helperText={errors[`farmer_${index}_aarajiNumber`] || "Type and press Enter to add multiple numbers"}
                            error={!!errors[`farmer_${index}_aarajiNumber`]}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Autocomplete
                        multiple
                        freeSolo
                        options={[]}
                        value={farmer.gataNumber ? farmer.gataNumber.toString().split(',').filter(x => x.trim() !== '') : []}
                        onChange={(event, newValue) => {
                          handleFarmerChange(index, 'gataNumber', newValue.join(','));
                        }}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Gata Number(s)"
                            placeholder="Type & Press Enter"
                            helperText="Type and press Enter to add multiple numbers"
                            required={!farmer.gataNumber}
                            error={!farmer.gataNumber && errors[`farmer_${index}_gataNumber`]}
                          />
                        )}
                      />
                    </Grid>

                    {/* <Grid item xs={12} md={4}>
                      <TextField fullWidth label="Unit Type"
                        value={farmer.unitType}
                        onChange={(e) => handleFarmerChange(index, 'unitType', e.target.value)}
                      />
                    </Grid> */}


                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Unit Type"
                        value={globalLand.unit || ''}
                        disabled
                        helperText="Auto-filled from Global Land Details"
                        required
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Total Rakba"
                        value={globalLand.totalRakba || ''}
                        disabled
                        inputProps={{
                          inputMode: "decimal"
                        }}
                        helperText="Auto-filled from Global Land Details"
                        required
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField fullWidth label="Khata Number"
                        value={formData.khataNo}
                        onChange={(e) => setFormData({ ...formData, khataNo: e.target.value })}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Vedhanic Ansh"
                        value={farmer.vedhanicAnsh}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || /^\d*\.?\d*$/.test(value)) {
                            const valNum = parseFloat(value) || 0;
                            const totalRakba = parseFloat(globalLand.totalRakba) || 0;
                            const otherFarmersSum = formData.farmers.reduce((sum, f, i) =>
                              i === index ? sum : sum + (parseFloat(f.vedhanicAnsh) || 0), 0);

                            if (valNum + otherFarmersSum > totalRakba) {
                              showAlert(`Cannot exceed Total Rakba (${totalRakba}). Available: ${(totalRakba - otherFarmersSum).toFixed(4)}`, 'warning', 'Limit Exceeded');
                              return;
                            }

                            handleFarmerChange(index, 'vedhanicAnsh', value);
                          }
                        }}
                        required
                        error={!!errors[`farmer_${index}_vedhanicAnsh`]}
                        helperText={errors[`farmer_${index}_vedhanicAnsh`] || 'Required field'}
                        inputProps={{
                          inputMode: "decimal"
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Rate Per Unit"
                        value={farmer.rate}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || /^\d*\.?\d*$/.test(value)) {
                            handleFarmerChange(index, 'rate', value);
                          }
                        }}
                        required
                        error={!!errors[`farmer_${index}_rate`]}
                        helperText={errors[`farmer_${index}_rate`] || 'Required field'}
                        inputProps={{
                          inputMode: "decimal"
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Total Amount"
                        value={farmer.totalAmount || 0}
                        onChange={(e) => handleFarmerChange(index, 'totalAmount', e.target.value)}
                        disabled
                      />
                    </Grid>


                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Paid Amount"
                        value={farmer.paidAmount || '0'}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value === '' || /^\d*\.?\d*$/.test(value)) {
                            handleFarmerChange(index, 'paidAmount', value);
                          }
                        }}
                        inputProps={{
                          inputMode: "decimal"
                        }}
                        helperText="Default value is 0"
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Outstanding Amount"
                        value={farmer.outstandingAmount || 0}
                        onChange={(e) => handleFarmerChange(index, 'outstandingAmount', e.target.value)}
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label={parseFloat(farmer.paidAmount || 0) > 0 ? "Payment Date " : "Payment Date"}
                        value={farmer.paymentDate}
                        type="date"
                        onChange={(e) => handleFarmerChange(index, 'paymentDate', e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                        required={parseFloat(farmer.paidAmount || 0) > 0}
                        error={parseFloat(farmer.paidAmount || 0) > 0 && !farmer.paymentDate}
                        helperText={
                          parseFloat(farmer.paidAmount || 0) > 0
                            ? (farmer.paymentDate ? '' : 'Required when paid amount > 0')
                            : 'Optional'
                        }
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        select
                        fullWidth
                        label={parseFloat(farmer.paidAmount || 0) > 0 ? "Payment Mode " : "Payment Mode"}
                        value={farmer.paymentMode || ''}
                        onChange={(e) => handleFarmerChange(index, 'paymentMode', e.target.value)}
                        required={parseFloat(farmer.paidAmount || 0) > 0}
                        error={parseFloat(farmer.paidAmount || 0) > 0 && !farmer.paymentMode}
                        helperText={
                          parseFloat(farmer.paidAmount || 0) > 0
                            ? (farmer.paymentMode ? '' : 'Required when paid amount > 0')
                            : 'Optional'
                        }
                        SelectProps={{
                          native: false,
                        }}
                        disabled={loadingPaymentModes}
                      >
                        <MenuItem value="">Select Payment Mode</MenuItem>
                        {loadingPaymentModes ? (
                          <MenuItem value="" disabled>Loading...</MenuItem>
                        ) : (
                          paymentModes.map((mode) => (
                            <MenuItem key={mode.id} value={mode.name}>
                              {mode.name}
                            </MenuItem>
                          ))
                        )}
                      </TextField>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label={parseFloat(farmer.paidAmount || 0) > 0 ? "Ref Number " : "Ref Number"}
                        value={farmer.refNumber}
                        onChange={(e) => handleFarmerChange(index, 'refNumber', e.target.value)}
                        required={parseFloat(farmer.paidAmount || 0) > 0}
                        error={parseFloat(farmer.paidAmount || 0) > 0 && !farmer.refNumber}
                        helperText={
                          parseFloat(farmer.paidAmount || 0) > 0
                            ? (farmer.refNumber ? '' : 'Required when paid amount > 0')
                            : 'Optional'
                        }
                      />
                    </Grid>


                    <Grid item xs={12} md={4}>
                      <Button
                        component="label"
                        variant="outlined"
                        fullWidth
                        startIcon={uploadingDocuments[`farmer_${index}_otherDocument`] ? <CircularProgress size={20} /> : <CloudUpload />}
                        color={documentUrls.farmers[index]?.otherDocuments ? "success" : "primary"}
                        disabled={uploadingDocuments[`farmer_${index}_otherDocument`]}
                      >
                        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                          {documentUrls.farmers[index]?.otherDocuments
                            ? `Other Document: Uploaded`
                            : uploadingDocuments[`farmer_${index}_otherDocument`]
                              ? "Uploading..."
                              : "Upload Seller Photo"}
                        </Box>
                        {documentUrls.farmers[index]?.otherDocuments && (
                          <IconButton
                            size="small"
                            color="primary"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              openImagePreview(documentUrls.farmers[index].otherDocuments, 'Other Document');
                            }}
                            sx={{ ml: 1 }}
                          >
                            <Visibility fontSize="small" />
                          </IconButton>
                        )}
                        <input
                          type="file"
                          hidden
                          accept="image/*,application/pdf"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              handleFarmerOtherDocumentUpload(index, file);
                            }
                          }}
                        />
                      </Button>
                    </Grid>

                  </Grid>

                </CardContent>
              </Card>
            ))}

            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
              <Button variant="contained" startIcon={<AddCircleOutline />} onClick={addFarmer}>Add sahkhatedar</Button>
              <Typography variant="body2" color="text.secondary">
                Allocated: {formData.farmers.reduce((sum, f) => sum + (parseFloat(f.vedhanicAnsh) || 0), 0).toFixed(4)} / Total: {globalLand.totalRakba || 0}
              </Typography>
            </Box>
          </Box>

          {/* <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom><Map color="primary" sx={{ mr: 1 }} />Area Details</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}><TextField fullWidth label="Total Area" value={formData.totalArea} onChange={(e) => setFormData({ ...formData, totalArea: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Unit"
                    value={formData.unit || ''}
                    onChange={(e) => setFormData({ ...formData, unit: e.target.value })}
                  >
          <MenuItem value="Biswa">Biswa</MenuItem>     
          <MenuItem value="Bigha">Bigha</MenuItem>
          <MenuItem value="Acre">Acre</MenuItem>
          <MenuItem value="Sq. Meter">Sq. Meter</MenuItem>
          <MenuItem value="Sq. Feet">Sq. Feet</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Rakhba (local term – mandatory)" value={formData.rakhba} onChange={(e) => setFormData({ ...formData, rakhba: e.target.value })} required /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Area as per Revenue Record" value={formData.areaRevenueRecord} onChange={(e) => setFormData({ ...formData, areaRevenueRecord: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Area as per Survey" value={formData.areaSurvey} onChange={(e) => setFormData({ ...formData, areaSurvey: e.target.value })} /></Grid>
              </Grid>
            </CardContent>
          </Card> */}

          <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom><Map color="primary" sx={{ mr: 1 }} />Boundary Details</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}><TextField fullWidth label="East Boundary" value={formData.eastBoundary} onChange={(e) => setFormData({ ...formData, eastBoundary: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="West Boundary" value={formData.westBoundary} onChange={(e) => setFormData({ ...formData, westBoundary: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="North Boundary" value={formData.northBoundary} onChange={(e) => setFormData({ ...formData, northBoundary: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="South Boundary" value={formData.southBoundary} onChange={(e) => setFormData({ ...formData, southBoundary: e.target.value })} /></Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom><Map color="primary" sx={{ mr: 1 }} />Legal Status</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Legal Status"
                    value={formData.legalStatus || ''}
                    onChange={(e) => setFormData({ ...formData, legalStatus: e.target.value })}
                  >
                    <MenuItem value="Clear">Clear</MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="Under Process">Under Process</MenuItem>
                    <MenuItem value="Disputed">Disputed</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Encumbrance Status"
                    value={formData.encumbranceStatus || ''}
                    onChange={(e) => setFormData({ ...formData, encumbranceStatus: e.target.value })}
                  >
                    <MenuItem value="Free">Free</MenuItem>
                    <MenuItem value="Loan">Loan</MenuItem>
                    <MenuItem value="Dispute">Dispute</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Court Case"
                    value={formData.courtCase || ''}
                    onChange={(e) => setFormData({ ...formData, courtCase: e.target.value })}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Bank Mortgage"
                    value={formData.bankMortgage || ''}
                    onChange={(e) => setFormData({ ...formData, bankMortgage: e.target.value })}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Lease / Agreement Exists"
                    value={formData.leaseAgreement || ''}
                    onChange={(e) => setFormData({ ...formData, leaseAgreement: e.target.value })}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom><Business color="primary" sx={{ mr: 1 }} />Purchase Agreement / Deal Details</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Agreement Type"
                    value={formData.agreementType || ''}
                    onChange={(e) => setFormData({ ...formData, agreementType: e.target.value })}
                  >
                    <MenuItem value="Agreement to Sell">Agreement to Sell</MenuItem>
                    <MenuItem value="Registered Sale Deed">Registered Sale Deed</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Total Deal Amount"
                    value={formData.totalDealAmount || '0.00'}
                    disabled
                    InputProps={{ startAdornment: '₹' }}
                    inputProps={{ inputMode: "decimal" }}
                    helperText="Auto-calculated from Shahkhatedar totals"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Advance Amount"
                    value={formData.advanceAmount || '0.00'}
                    disabled
                    InputProps={{ startAdornment: '₹' }}
                    inputProps={{ inputMode: "decimal" }}
                    helperText="Auto-calculated from Shahkhatedar paid amounts"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Balance Amount"
                    value={formData.balanceAmount || '0.00'}
                    disabled
                    InputProps={{ startAdornment: '₹' }}
                    inputProps={{ inputMode: "decimal" }}
                    helperText="Auto-calculated from Shahkhatedar outstanding amounts"
                  />
                </Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Stamp Duty Value" value={formData.stampDutyValue} onChange={(e) => {
                  const value = e.target.value;
                  if (value === '' || /^\d*\.?\d*$/.test(value)) {
                    setFormData({ ...formData, stampDutyValue: value });
                  }
                }} InputProps={{ startAdornment: '₹' }} inputProps={{ inputMode: "decimal" }} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Circle Rate" value={formData.circleRate} onChange={(e) => {
                  const value = e.target.value;
                  if (value === '' || /^\d*\.?\d*$/.test(value)) {
                    setFormData({ ...formData, circleRate: value });
                  }
                }} InputProps={{ startAdornment: '₹' }} inputProps={{ inputMode: "decimal" }} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Registry Date (planned / actual)" type="date" InputLabelProps={{ shrink: true }} inputProps={{ style: { padding: 16 } }} value={formData.registryDate} onChange={(e) => setFormData({ ...formData, registryDate: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Mutation Date" type="date" InputLabelProps={{ shrink: true }} inputProps={{ style: { padding: 16 } }} value={formData.mutationDate} onChange={(e) => setFormData({ ...formData, mutationDate: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Broker / Mediator Name (if any)" value={formData.brokerName} onChange={(e) => setFormData({ ...formData, brokerName: e.target.value })} inputProps={{ style: { padding: 16 } }} /></Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom><Calculate color="primary" sx={{ mr: 1 }} />Payment Details (Farmer Ledger System)</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}><TextField fullWidth label="Payment ID" value={formData.paymentId} onChange={(e) => setFormData({ ...formData, paymentId: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Farmer / Khatedar Name" value={formData.paymentFarmerName} onChange={(e) => setFormData({ ...formData, paymentFarmerName: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Land Reference (Khata + Gata)" value={formData.paymentLandReference} onChange={(e) => setFormData({ ...formData, paymentLandReference: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Payment Date" type="date" InputLabelProps={{ shrink: true }} value={formData.paymentDate} onChange={(e) => setFormData({ ...formData, paymentDate: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Payment Type"
                    value={formData.paymentType || ''}
                    onChange={(e) => setFormData({ ...formData, paymentType: e.target.value })}
                  >
                    <MenuItem value="Cash">Cash</MenuItem>
                    <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                    <MenuItem value="Cheque">Cheque</MenuItem>
                    <MenuItem value="RTGS / NEFT / IMPS">RTGS / NEFT / IMPS</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Bank Name" value={formData.bankName} onChange={(e) => setFormData({ ...formData, bankName: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Reference / UTR / Cheque No" value={formData.referenceNumber} onChange={(e) => setFormData({ ...formData, referenceNumber: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Amount" value={formData.paymentAmount} onChange={(e) => {
                  const value = e.target.value;
                  if (value === '' || /^\d*\.?\d*$/.test(value)) {
                    setFormData({ ...formData, paymentAmount: value });
                  }
                }} InputProps={{ startAdornment: '₹' }} inputProps={{ inputMode: "decimal" }} /></Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    fullWidth
                    label="Paid For"
                    value={formData.paidFor || ''}
                    onChange={(e) => setFormData({ ...formData, paidFor: e.target.value })}
                  >
                    <MenuItem value="Advance">Advance</MenuItem>
                    <MenuItem value="Installment">Installment</MenuItem>
                    <MenuItem value="Final Payment">Final Payment</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}><TextField fullWidth label="Remarks" value={formData.paymentRemarks} onChange={(e) => setFormData({ ...formData, paymentRemarks: e.target.value })} /></Grid>
                <Grid item xs={12} md={4}>
                  <Button
                    component="label"
                    variant="outlined"
                    fullWidth
                    startIcon={uploadingDocuments[`paymentAttachment`] ? <CircularProgress size={20} /> : <CloudUpload />}
                    color={documentUrls.paymentAttachment ? "success" : "primary"}
                    disabled={uploadingDocuments[`paymentAttachment`]}
                  >
                    <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                      {documentUrls.paymentAttachment 
                        ? `Attachment: Uploaded` 
                        : uploadingDocuments[`paymentAttachment`] 
                          ? "Uploading..." 
                          : "Attachment (Receipt / Bank Proof)"}
                    </Box>
                    {documentUrls.paymentAttachment && (
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          openImagePreview(documentUrls.paymentAttachment, 'Payment Attachment');
                        }}
                        sx={{ ml: 1 }}
                      >
                        <Visibility fontSize="small" />
                      </IconButton>
                    )}
                    <input
                      type="file"
                      hidden
                      accept="image/*,application/pdf"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          handlePaymentAttachmentUpload(file);
                        }
                      }}
                    />
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card> */}

          <Card variant="outlined" sx={{ mb: 3, borderRadius: 2 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom><AttachFile color="primary" sx={{ mr: 1 }} />Land Documents</Typography>
              <Typography variant="subtitle2" sx={{ mt: 1, mb: 1 }}>General documents for this land registry</Typography>
              <Box sx={{
                display: 'flex',
                gap: 2,
                flexWrap: 'wrap',
                p: 2,
                bgcolor: '#f8f9fa',
                borderRadius: 1,
                border: '1px solid #e9ecef'
              }}>
                {landDocTypes.map(doc => {
                  const docKeyMap = {
                    'Khatauni Certificate': 'kahtuniCertificate',
                    'Purchase Agreement': 'purchaseAgreement',
                    'Land Revenue Receipt': 'landRevenueReceipt'
                  };

                  const docKey = docKeyMap[doc] || doc.replace(/\s+/g, '').toLowerCase();
                  const isUploaded = documentUrls.land?.[docKey];
                  const isUploading = uploadingDocuments[`land_${docKey}`];

                  return (
                    <Button
                      key={doc}
                      component="label"
                      variant="outlined"
                      size="small"
                      startIcon={isUploading ? <CircularProgress size={20} /> : <CloudUpload />}
                      color={isUploaded ? "success" : "primary"}
                      disabled={isUploading}
                      sx={{
                        minWidth: 200,
                        width: { xs: '100%', sm: 287 },
                        textTransform: 'none',
                        position: 'relative'
                      }}
                    >
                      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                        {isUploaded
                          ? `${doc} uploaded`
                          : isUploading
                            ? "Uploading..."
                            : `Upload ${doc}`}
                      </Box>

                      {isUploaded && (
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            openImagePreview(isUploaded, doc);
                          }}
                          sx={{ ml: 1 }}
                        >
                          <Visibility fontSize="small" />
                        </IconButton>
                      )}
                      <input
                        type="file"
                        hidden
                        accept="image/*,application/pdf"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            if (doc === 'Khatauni Certificate') {
                              handleLandDocumentUpload('kahtuniCertificate', file);
                            } else if (doc === 'Purchase Agreement') {
                              handleLandDocumentUpload('purchaseAgreement', file);
                            } else if (doc === 'Land Revenue Receipt') {
                              handleLandDocumentUpload('landRevenueReceipt', file);
                            } else {
                              handleLandDocumentUpload(docKey, file);
                            }
                          }
                        }}
                      />
                    </Button>
                  );
                })}

                <Button
                  component="label"
                  variant="outlined"
                  size="small"
                  startIcon={uploadingDocuments[`land_otherDocument`] ? <CircularProgress size={20} /> : <CloudUpload />}
                  color={documentUrls.land?.otherDocuments ? "success" : "primary"}
                  disabled={uploadingDocuments[`land_otherDocument`]}
                  sx={{
                    minWidth: 200,
                    width: { xs: '100%', sm: 287 },
                    justifyContent: 'flex-start',
                    textTransform: 'none'
                  }}
                >
                  <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                    {documentUrls.land?.otherDocuments
                      ? `Other Document uploaded`
                      : uploadingDocuments[`land_otherDocument`]
                        ? "Uploading..."
                        : `Upload Other Document`}
                  </Box>

                  {documentUrls.land?.otherDocuments && (
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        openImagePreview(documentUrls.land.otherDocuments, 'Other Land Document');
                      }}
                      sx={{ ml: 1 }}
                    >
                      <Visibility fontSize="small" />
                    </IconButton>
                  )}
                  <input
                    type="file"
                    hidden
                    accept="image/*,application/pdf"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        handleLandOtherDocumentUpload(file);
                      }
                    }}
                  />
                </Button>
              </Box>
            </CardContent>
          </Card>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Button
              variant="contained"
              size="large"
              fullWidth
              startIcon={<Save />}
              onClick={async () => {
                const recalculatedFarmers = formData.farmers.map(farmer => {
                  const vedhanicAnsh = parseFloat(farmer.vedhanicAnsh) || 0;
                  const rate = parseFloat(farmer.rate) || 0;
                  const totalAmount = vedhanicAnsh * rate;

                  const paidAmount = parseFloat(farmer.paidAmount) || 0;
                  const outstandingAmount = totalAmount - paidAmount;

                  return {
                    ...farmer,
                    totalAmount: totalAmount,
                    outstandingAmount: outstandingAmount
                  };
                });

                const updatedFormData = {
                  ...formData,
                  farmers: recalculatedFarmers,
                  state: formData.state || globalLand.state,
                  district: formData.district || globalLand.district,
                  tehsil: formData.tehsil || globalLand.tehsil,
                  village: formData.village || globalLand.village,
                  khataNo: formData.khataNo || globalLand.khataNumber,
                  gataNo: formData.gataNo || globalLand.gataNumber,
                  landType: formData.landType || globalLand.landType,
                  landUsage: formData.landUsage || globalLand.landUsage,
                  unit: formData.unit || globalLand.unit,
                  totalRakba: formData.totalRakba || globalLand.totalRakba,
                };
                const result = await submitForm(updatedFormData);
                if (result && onAddPurchase) {
                  onAddPurchase(result);
                }
              }}
              disabled={isSubmitting}
              sx={{ width: { xs: '100%', md: 'auto' }, px: 4 }}
            >
              {isSubmitting ? 'Saving...' : 'Save All Details'}
            </Button>
            {errors.project && <Typography color="error" variant="caption">{errors.project}</Typography>}
          </Box>
        </Grid>

      </Grid>
      <Snackbar open={!!successMessage} autoHideDuration={3000} onClose={() => setSuccessMessage('')}>
        <Alert severity="success">{successMessage}</Alert>
      </Snackbar>

      {/* Add City Dialog */}
      <Dialog open={addCityDialogOpen} onClose={() => setAddCityDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add New City</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="State"
                value={formData.farmers[currentFarmerIndex]?.state || ''}
                disabled
                helperText="City will be added to this state"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="City Name"
                value={newCityName}
                onChange={(e) => setNewCityName(e.target.value)}
                required
                autoFocus
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddCityDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={async () => {
              if (newCityName.trim()) {
                handleFarmerAddressChange(currentFarmerIndex, 'district', newCityName);
                setAddCityDialogOpen(false);
                setNewCityName('');
              }
            }}
            variant="contained"
            disabled={!newCityName.trim()}
          >
            Add City
          </Button>
        </DialogActions>
      </Dialog>

      {/* Image Preview Dialog */}
      <Dialog open={imageDialogOpen} onClose={() => setImageDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {imageDialogTitle}
          <IconButton onClick={() => setImageDialogOpen(false)} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ textAlign: 'center', p: 0, minHeight: '400px' }}>
          {imageDialogUrl.toLowerCase().endsWith('.pdf') ? (
            <iframe src={imageDialogUrl} title="PDF Preview" width="100%" height="600px" style={{ border: 'none' }} />
          ) : (
            <Box sx={{ p: 2 }}>
              <img
                src={imageDialogUrl}
                alt="Preview"
                style={{ maxWidth: '100%', maxHeight: '75vh', objectFit: 'contain' }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://via.placeholder.com/400?text=Image+Load+Failed';
                }}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => window.open(imageDialogUrl, '_blank')} color="primary">
            Open in New Tab
          </Button>
          <Button onClick={() => setImageDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <AlertModal
        open={alertConfig.open}
        title={alertConfig.title}
        message={alertConfig.message}
        type={alertConfig.type}
        onClose={() => setAlertConfig({ ...alertConfig, open: false })}
      />

      <ConfirmModal
        open={confirmConfig.open}
        title={confirmConfig.title}
        onClose={() => setConfirmConfig({ ...confirmConfig, open: false })}
        onConfirm={() => {
          if (confirmConfig.onConfirm) confirmConfig.onConfirm();
          setConfirmConfig({ ...confirmConfig, open: false });
        }}
        type="warning"
      >
        {confirmConfig.message}
      </ConfirmModal>
    </Container >
  );
};

export default AddPurchasePage;
